import { ReactComponentElement } from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import noop from 'lodash/noop';
import { Link as RouterLink } from 'react-router-dom';
import { BlockLink, Flex, LinkProps, Text } from 'roo-ui/components';

export interface ItemLinkProps extends LinkProps {
  url: string;
  external?: boolean;
  alert?: ReactComponentElement<any>;
  [key: string]: any;
}

const Link = styled(BlockLink)`
  text-transform: uppercase;
  margin-bottom: ${themeGet('space.2')};

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const ItemLink = ({ label, url, external = false, onClick = noop, alert, ...rest }: ItemLinkProps) => (
  <Link as={external ? 'a' : RouterLink} to={url} href={url} onClick={onClick} {...rest}>
    <Flex justifyContent="space-between" flexDirection="column">
      <Text color="red" fontSize={16} letterSpacing={1.5} fontWeight="bold">
        {label}
      </Text>
      {alert}
    </Flex>
  </Link>
);
